

import React, {useState} from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TimeSlotReportGraph from './TimeSlotReportGraph';

function ReportTab() {


  return (
    <div>
      <Container maxWidth={false}>
        {/* <DriverOrderReportTable /> */}
        <TimeSlotReportGraph />
      </Container>
    </div>
  );
}

export default ReportTab;
